export const techStack = [
  // {
  //   name: "C Language",
  //   link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-plain.svg",
  // },
  {
    name: "HTML 5",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
  },
  {
    name: "CSS",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain.svg",
  },
  {
    name: "Bootstrap",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-plain.svg",
  },
  {
    name: "Sass",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/sass/sass-original.svg",
  },
  {
    name: "Tailwind CSS",
    link: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
  },
  {
    name: "Ant Design",
    link: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
  },
  {
    name: "Figma",
    link: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
  },
  {
    name: "Photoshop",
    link: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
  },
  {
    name: "Adobe XD",
    link: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
  },
  {
    name: "Javascript",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
  },
  {
    name: "Material UI",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
  },
  
  {
    name: "React",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg",
  },
  {
    name: "Redux",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
  },

  // {
  //   name: "TypeScript",
  //   link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
  // },
  // {
  //   name: "Express",
  //   link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original-wordmark.svg",
  // },

  // {
  //   name: "NodeJS",
  //   link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg",
  // },
  // {
  //   name: "Postman",
  //   link: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
  // },

  // {
  //   name: "Dart",
  //   link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dart/dart-original.svg",
  // },
  // {
  //   name: "Flutter",
  //   link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-plain.svg",
  // },
  // {
  //   name: "React Native",
  //   link: "https://pagepro.co/blog/wp-content/uploads/2020/03/react-native-logo-884x1024.png",
  // },
  
  
  
  {
    name: "SQl",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-plain.svg",
  },
  // {
  //   name: "Mongo DB",
  //   link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain.svg",
  // },
  // {
  //   name: "Heroku",
  //   link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/heroku/heroku-plain.svg",
  // },
  // { name: "Azure", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-plain.svg" },
  {
    name: "Git",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg",
  },
  // { name: "Docker", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-plain.svg" },
  // {
  //   name: "Firebase",
  //   link: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
  // },

  // { name: "Bash", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bash/bash-original.svg" },
  // { name: "Vim", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vim/vim-original.svg" },

  // { name: "VS Code", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg" },
  // {name: "", link: "https://repository-images.githubusercontent.com/59065830/b62be480-45d2-11ea-9989-803db0f9c44d"}
];

// export const contactLinks = [{ name: 'Stack Overflow', url: 'https://img.icons8.com/external-tal-revivo-color-tal-revivo/40/000000/external-stack-overflow-is-a-question-and-answer-site-for-professional-logo-color-tal-revivo.png', link: 'https://stackoverflow.com/users/11788531/aakash-sharma' },
// { name: 'Instagram', url: 'https://img.icons8.com/doodle/40/000000/instagram-new--v2.png', link: 'https://www.instagram.com/aakashsh1999/' },
// { name: 'Github', url: 'https://img.icons8.com/doodle/40/000000/github--v1.png', link :'https://github.com/aakashsh1999'},
// { name: 'LinkedIn', url: 'https://img.icons8.com/doodle/40/000000/linkedin--v2.png', link: 'https://www.linkedin.com/in/aakashsh1999/'}
// ]

export const contactLinks = [
  {
    name: "Stack Overflow",
    url: "https://img.icons8.com/external-tal-revivo-color-tal-revivo/40/000000/external-stack-overflow-is-a-question-and-answer-site-for-professional-logo-color-tal-revivo.png",
    link: "https://stackoverflow.com",
  },
  {
    name: "Instagram",
    url: "https://img.icons8.com/doodle/40/000000/instagram-new--v2.png",
    link: "https://www.instagram.com/",
  },
  {
    name: "Github",
    url: "https://img.icons8.com/doodle/40/000000/github--v1.png",
    link: "https://github.com/pguru1214",
  },
  {
    name: "LinkedIn",
    url: "https://img.icons8.com/doodle/40/000000/linkedin--v2.png",
    link: "https://www.linkedin.com/in/gurupasad0346",
  },
];

export const serviceData = [
  {
    name: "UI Development",
    desc: "UI Developer encompasses many different skills and disciplines in the production and maintenance of websites. The different areas of web design include web graphic design user interface design  authoring, including standardised code and proprietary software user experience design and search engine",
    img: "https://img.icons8.com/external-kiranshastry-lineal-color-kiranshastry/64/000000/external-web-development-coding-kiranshastry-lineal-color-kiranshastry.png",
  },
  {
    name: "Front-End Development",
    desc: `We provide a range of Front-End development services
    including custom mobile development on Web Pages, building
    cross-platform apps, designing user experience and integrating
    novel mobile interfaces such as chat and voice`,
    img: "https://img.icons8.com/external-justicon-lineal-color-justicon/64/000000/external-app-development-responsive-web-design-justicon-lineal-color-justicon.png",
  },

  {
    name: "UX Desining",
    desc: `UX design is a craft where professionals create visual
    content to communicate messages. By applying visual hierarchy and
    page layout techniques, designers use typography and pictures to
    meet users' specific needs and focus on the logic of displaying
    elements in interactive designs, to optimize the user experience.`,
    img: "https://img.icons8.com/external-flaticons-flat-flat-icons/64/000000/external-backend-no-code-flaticons-flat-flat-icons.png",
  },
];
